export default __webpack_public_path__ + "static/media/31.d225adbd.gif";